import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_1216 implements Validator {

    public static id = 'CTRL_1216';
    private siretEtat = '11000201100044';
    private message = 'error.ctr_1216';


    public LOG: LogService = new LogService(CTRL_1216);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1216.id + '_');
        const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const firstNameWithStepId = ctrlMap.get(ctrl.value.rgCtrls.etat);
                const secondNameWithStepId = ctrlMap.get(ctrl.value.rgCtrls.siret);
                const firstCtrl = form.controls[firstNameWithStepId];
                const secondCtrl = form.controls[secondNameWithStepId];
                if (firstCtrl.value === 'etat' && secondCtrl.value !== this.siretEtat ) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
